import React from "react";
import UnitInput from "../parts/inputs/unit-input";
import BackArrowButton from "../parts/back-arrow-button";
import LoginWrapper from "./LoginWrapper";

const SignupParq2View = (props) => {
  React.useEffect(() => {
    const { avatar } = props.state;

    if (avatar instanceof File) {
      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(avatar);
      document.getElementById("avatar-input").files = dataTransfer.files;
    }
  }, []);

  const finishNoCheck = (e) => {
    e.preventDefault();
    document.getElementById("submit-athlete-button").click();
  };

  const { onBack, state } = props;

  return (
    <LoginWrapper
      mainClass="Onboarding athlete full-w parq-answered"
      left={
        <form
          action="/finish-onboarding"
          method="POST"
          encType="multipart/form-data"
        >
          <section>
            <BackArrowButton onBack={() => onBack(6)} />
          </section>

          <section>
            <h2 className="clipped w-fit">If you answered YES</h2>
            <p className="!ml-0 mt-3 !text-[--white]">
              If you answered yes to one or more questions, are older than age
              40, and have been inactive or are concerned about your health,
              consult a physician before taking a fitness test or substantially
              increasing your physical activity.
              <br />
              Ask for a medical clearance along with information about specific
              exercise limitations you may have. In most cases, you will still
              be able to do any type of activity you want, as long as you adhere
              to some guidelines.
            </p>

            <h2 className="clipped w-fit mt-12">If you answered NO</h2>
            <p className="!ml-0 mt-3 !text-[--white]">
              If you answered no to all the PAR-Q questions, you can be
              reasonably sure that you can exercise safely and have a low risk
              of having any medical complications from exercise. It is still
              important to start slowly and increase gradually. It may also be
              helpful to have a fitness assessment with a personal trainer or
              coach in order to determine where to begin. <br />
              Keep in mind that if your health changes so that you then answer
              "Yes" to any of the PAR-Q questions, tell your fitness or health
              professional. You may need to change your physical activity plan.
            </p>

            <div className="hidden">
              <input
                id="avatar-input"
                type="file"
                name="avatar"
                accept="image/*"
              />
              <input
                name="agreeTOS"
                type="checkbox"
                id="tos-copy"
                defaultChecked={state.agreeTOS}
              />
              <input
                id="email-copy"
                type="email"
                name="email"
                defaultValue={state.email}
                required
              />
              {state.repMaxBench > 0 && (
                <UnitInput
                  required
                  min="1"
                  metric="kg"
                  units={state.units}
                  imperial="lb"
                  name="bench"
                  value={state.repMaxBench}
                />
              )}
              {state.repMaxDeadlift > 0 && (
                <UnitInput
                  required
                  min="1"
                  metric="kg"
                  imperial="lb"
                  units={state.units}
                  name="deadlift"
                  value={state.repMaxDeadlift}
                />
              )}
              {state.repMaxSquat > 0 && (
                <UnitInput
                  required
                  min="1"
                  metric="kg"
                  imperial="lb"
                  units={state.units}
                  name="squat"
                  value={state.repMaxSquat}
                />
              )}
              {state.repMaxClean > 0 && (
                <UnitInput
                  required
                  min="1"
                  metric="kg"
                  imperial="lb"
                  units={state.units}
                  name="clean"
                  value={state.repMaxClean}
                />
              )}
              {state.repMaxJerk > 0 && (
                <UnitInput
                  required
                  min="1"
                  metric="kg"
                  imperial="lb"
                  units={state.units}
                  name="jerk"
                  value={state.repMaxJerk}
                />
              )}
              {state.repMaxSnatch > 0 && (
                <UnitInput
                  required
                  min="1"
                  metric="kg"
                  imperial="lb"
                  units={state.units}
                  name="snatch"
                  value={state.repMaxSnatch}
                />
              )}
              {state.repMaxOverheadPress > 0 && (
                <UnitInput
                  required
                  min="1"
                  metric="kg"
                  imperial="lb"
                  units={state.units}
                  name="overheadPress"
                  value={state.repMaxOverheadPress}
                />
              )}
              <input
                type="password"
                name="password"
                required
                defaultValue={state.passwordSignup}
              />
              <input
                type="password"
                name="confirmPassword"
                required
                defaultValue={state.confirmPasswordSignup}
              />
              <input
                type="text"
                name="confirmCode"
                required
                defaultValue={state.code}
              />
              <input
                type="text"
                name="firstName"
                defaultValue={state.firstName}
                required
              />
              <input
                type="text"
                name="lastName"
                defaultValue={state.lastName}
                required
              />
              <input
                type="radio"
                name="units"
                defaultChecked={true}
                defaultValue={state.units}
              />
              <input
                type="text"
                name="preferredLoadInput"
                defaultValue="weight"
              />
              <input type="text" name="timeZone" defaultValue="0b" />
              <input
                type="text"
                name="heartCondition"
                defaultValue={state.heartCondition}
              />
              <input
                type="text"
                name="chestPain"
                defaultValue={state.chestPain}
              />
              <input
                type="text"
                name="pastMonthChestPain"
                defaultValue={state.pastMonthChestPain}
              />
              <input
                type="text"
                name="dizzinesConsciousnessLoss"
                defaultValue={state.dizzinesConsciousnessLoss}
              />
              <input
                type="text"
                name="boneJointProblem"
                defaultValue={state.boneJointProblem}
              />
              <input
                type="text"
                name="bloodPressurePrescription"
                defaultValue={state.bloodPressurePrescription}
              />
              <input
                type="text"
                name="reasonForNoPhysicalAct"
                defaultValue={state.reasonForNoPhysicalAct}
              />

              <input id="submit-athlete-button" type="submit" />
            </div>

            <button
              data-button-type="primary"
              sz="large"
              onClick={finishNoCheck}
              className="only-show-mobile"
            >
              Start training
            </button>
          </section>

          <button
            data-button-type="primary"
            sz="large"
            onClick={finishNoCheck}
            className="!w-1/2 mobile-hidden"
          >
            Start training
          </button>
        </form>
      }
    />
  );
};

export default SignupParq2View;
